/**
 * The visible fallback's probe (plan-019 WID-CORE; OD-24; ED-24; design §31.8.9; research ad-block §6.6).
 *
 * A closed root does not protect the host: a generic blocker rule (`##wt-hp`, a `display: none` on a tag it dislikes)
 * hides `<wt-hp>` and everything in it. The widget cannot stop that; it can notice it and tell the host, which then
 * reveals its plain "Help" link to the fallback page. The check runs on the next two animation frames and once more
 * after two seconds (a cosmetic filter is often applied a little after load), and reports at most once.
 */
/** When the last check runs, after mount. */
export const HELP_PROBE_LATE_MS = 2_000;
export const measureHostVisible = (host) => {
    const view = host.ownerDocument.defaultView;
    if (view === null || !host.isConnected)
        return false;
    const style = view.getComputedStyle(host);
    if (style.display === "none" || style.visibility === "hidden" || style.visibility === "collapse")
        return false;
    if (style.opacity === "0")
        return false;
    const box = host.getBoundingClientRect();
    return box.width > 0 && box.height > 0;
};
/** Starts the probe; `onHidden` runs at most once. Returns the cancel. */
export function probeHostVisibility(host, measure, onHidden) {
    const view = host.ownerDocument.defaultView;
    if (view === null)
        return () => undefined;
    let done = false;
    let frame = 0;
    const check = () => {
        if (done)
            return;
        if (!measure(host)) {
            done = true;
            onHidden();
        }
    };
    frame = view.requestAnimationFrame(() => {
        check();
        frame = view.requestAnimationFrame(check);
    });
    const late = view.setTimeout(() => {
        check();
        done = true;
    }, HELP_PROBE_LATE_MS);
    return () => {
        done = true;
        view.cancelAnimationFrame(frame);
        view.clearTimeout(late);
    };
}
//# sourceMappingURL=probe.js.map